import React from 'react';
import { FaCogs } from 'react-icons/fa';
import { AttentionMessage, Card, Container, Heading, HStack, VStack } from '@tq/ui-components';
import { COLOURS } from '@tq/ui-components/dist/pp2/theme';

export const ErrorContent: React.FC<{ title: string; description: string }> = ({
  title,
  description,
}) => {
  return (
    <Container w={{ base: '100%', md: '75%' }}>
      <Card p={{ base: 4, md: 64 }} boxShadow='base'>
        <VStack display='grid' gridGap={{ base: 4, md: 6 }}>
          <HStack>
            <FaCogs size={32} color={COLOURS.blue[600]} />
            <Heading>{title}</Heading>
          </HStack>
          <AttentionMessage status='info' description={description} />
        </VStack>
      </Card>
    </Container>
  );
};
